import React, { CSSProperties, FC, ReactNode } from 'react'
import Icon from 'components/base-ui/Icon'
import { ParagraphLarge } from 'components/base-ui/FontsV2'
import { TitleMd, TitleSm, LabelBoxWrapper, IconWrapper } from './styled'
import { LabelBoxEnumStr, LabelBoxSizeEnumStr } from '.'

interface Props {
  title?: string
  text: ReactNode | string
  type: LabelBoxEnumStr
  size?: LabelBoxSizeEnumStr
  style?: CSSProperties
}

const LabelBox: FC<Props> = ({ title, text, type, size = 'md', ...rest }) => {
  return (
    <LabelBoxWrapper type={type} {...rest}>
      {type && (
        <IconWrapper type={type}>
          {type === 'success' && <Icon name="check" />}
          {(type === 'warning' || type === 'error' || type === 'errorLight') && <Icon name="warning-triangle-redius" />}
          {(type === 'info' || type === 'infoDark') && (
            <Icon style={{ position: 'relative', top: '3px' }} name="notice-circle-2" />
          )}
          {type === 'infoLight' && <Icon style={{ position: 'relative', top: '2px' }} name="information" />}
        </IconWrapper>
      )}
      <div>
        {title && size === 'md' && <TitleMd type={type}>{title}</TitleMd>}
        {title && size === 'sm' && <TitleSm type={type}>{title}</TitleSm>}
        {text && <ParagraphLarge>{text}</ParagraphLarge>}
      </div>
    </LabelBoxWrapper>
  )
}

export default LabelBox
